module.exports = __webpack_public_path__ + "img/2.c9aa5f1e.png";